import {api} from './_ApiFactoryWithHeader';

export async function loadPerformanceDashboard(start, end, cancelToken) {
    const response = await api.get('suppliers', {
        $select: 'supplier_id,name,endpoint', $top: 1000,
    }, null, cancelToken);
    if (!response || response.status !== 200 || !Array.isArray(response.data)) {
        throw new Error('Unable to load auction platforms.');
    }
    const endpoints = new Set();
    const suppliers = response.data.filter(supplier => {
        if (!supplier.endpoint) return true;
        const endpoint = supplier.endpoint.replace(/\/+$/, '');
        if (endpoints.has(endpoint)) return false;
        endpoints.add(endpoint);
        return true;
    });
    return Promise.all(suppliers.map(async supplier => {
        const source = {id: supplier.supplier_id, name: supplier.name, events: []};
        if (!supplier.endpoint) return {...source, status: 'unavailable'};
        try {
            const result = await api.get(
                `${supplier.endpoint.replace(/\/+$/, '')}/client_performance_dashboard`,
                {start, end}, null, cancelToken
            );
            if (result && result.status === 200 && result.data && Array.isArray(result.data.events)) {
                return {...source, status: 'available', events: result.data.events.map(event => ({
                    ...event, supplier_id: supplier.supplier_id, supplier_name: supplier.name,
                }))};
            }
            const status = result && result.status;
            return {...source, status: status === 404 ? 'unavailable'
                : status === 403 || status === 401 ? 'forbidden'
                : status === 400 ? 'range' : 'failed'};
        } catch (error) {
            return {...source, status: 'failed'};
        }
    }));
}
